import type { SatisKaynaklari } from './ekranKaynaklari';

/** Satis Analiz'in tematik sekmeleri (kullanici, 2026-11-01). Her biri tek soruya cevap verir. */
export type SaSekme = 'genel' | 'kanal' | 'urun' | 'kar';

export const VARSAYILAN_SEKME: SaSekme = 'genel';

export const SEKMELER: ReadonlyArray<{ anahtar: SaSekme; ad: string }> = [
  { anahtar: 'genel', ad: 'Genel' },
  { anahtar: 'kanal', ad: 'Kanal ve şube' },
  { anahtar: 'urun', ad: 'Ürün ve kategori' },
  { anahtar: 'kar', ad: 'Kârlılık' },
];

export function saSekmeMi(x: string | null): x is SaSekme {
  return SEKMELER.some((s) => s.anahtar === x);
}

/** Firmanin kaynaklarinda karsiligi olmayan sekme cizilmez; Template ekrani birden cok firmada ortak. */
export function sekmeVarMi(sekme: SaSekme, k: SatisKaynaklari): boolean {
  switch (sekme) {
    case 'genel':
      return true;
    case 'kanal':
      return !!k.kanal040;
    case 'urun':
      return !!(k.kategori || k.enCokSatan || k.sepet019 || (k.cokSatan014 && k.kritik025));
    case 'kar':
      return !!(k.urunKarliligi || k.zararinaSatis);
  }
}
